import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  jobDate: {
    id: 'sosSubForm.editTowingRecord.jobDate',
    defaultMessage: 'Työn pvm',
  },
  vehicleMileage: {
    id: 'sosSubForm.editTowingRecord.vehicleMileage',
    defaultMessage: 'Mittarilukema',
  },
  insuranceCompany: {
    id: 'sosSubForm.editTowingRecord.insuranceCompany',
    defaultMessage: 'Vakuutusyhtiö',
  },
  caseNumber: {
    id: 'sosSubForm.editTowingRecord.caseNumber',
    defaultMessage: 'SOS Viite',
  },
  agreementName: {
    id: 'sosSubForm.editTowingRecord.agreementName',
    defaultMessage: 'Konsepti',
  },
  deliverable: {
    id: 'sosSubForm.editTowingRecord.deliverable',
    defaultMessage: 'Toimenpide',
  },
  cause: {
    id: 'sosSubForm.editTowingRecord.cause',
    defaultMessage: 'Vika',
  },
  additionalInfo: {
    id: 'sosSubForm.editTowingRecord.additionalInfo',
    defaultMessage: 'Työn lisätiedot',
  },
  notes: {
    id: 'sosSubForm.editTowingRecord.notes',
    defaultMessage: 'Muistiinpanot (sisäiset)',
  },
  situationDescription: {
    id: 'sosSubForm.editTowingRecord.situationDescription',
    defaultMessage: 'SOS Merkinnät',
  },
})
